// Link-coloured text for a value with no anchor. Styled in controllers/admin.scss,
// beside the `.ag-cell a` rule it borrows its colour from.

export const ACCENT_TEXT_CLASS = "ag-grid-accent-text";

export function buildAccentText(text: string): HTMLSpanElement {
  const span = document.createElement("span");
  span.className = ACCENT_TEXT_CLASS;
  span.textContent = text;
  return span;
}
